<section class="relative py-9">
  <div class="mask-curve-top-div bg-anis"></div>
  <div class="relative z-10 flex h-[680px] flex-col bg-anis pt-[50px]">
    <div class="centered-with-padding">
      <div class="desk:pb-7 desk:pt-14">
        @if (data.pictos; as pictos) {
          <div class="hidden desk:flex" data-rellax-percentage="1" data-rellax-speed="2" parallax>
            @for (picto of pictos; track index; let index = $index) {
              <app-svg
                [height]="143"
                [ngClass]="{
                  'rotate-[1deg]': index === 0,
                  'rotate-[-4deg] -ml-[15px]': index === 1,
                  'rotate-[6deg] -ml-[5px]': index === 2,
                }"
                [src]="picto.svg"
                [width]="120" />
            }
          </div>
          <div
            class="relative mx-auto w-[235px] desk:hidden"
            data-rellax-percentage="1"
            data-rellax-speed="1.5"
            parallax>
            <div class="h-[300px] w-[235px]">
              @for (picto of pictos; track index; let index = $index) {
                @let width = index === 0 ? 135 : index === 1 ? 108 : 103;
                @let height = index === 0 ? 161 : index === 1 ? 129 : 123;
                <app-svg
                  [height]="height"
                  [ngClass]="{
                    'rotate-[6deg] bottom-[96px] right-[-8px] z-20': index === 0,
                    'rotate-[4deg] bottom-[186px] left-[15px] z-10': index === 1,
                    'rotate-[-8deg] bottom-[40px] left-[20px] z-30': index === 2,
                  }"
                  [src]="picto.svg"
                  [width]="width"
                  class="absolute" />
              }
            </div>
          </div>
        }
      </div>
      @if (data.title; as title) {
        <app-title [title]="title" size="custom-35" />
      }
    </div>
  </div>
  <div class="mask-curve-bottom-div bg-anis"></div>
</section>
